const getAspectRatioFromImageSource = async (source) => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.src = source;
    img.onload = () => {
      resolve([img.width, img.height]);
    };
  });
};
export default getAspectRatioFromImageSource;
